import { AbstractControl } from '@angular/forms';
import { Column } from './column';
import { DataSet } from './data-set';
import { Row } from './row';

export class Cell {
  protected static PREPARE = (value: any) => value;
  public newValue: any = '';

  constructor(
    protected value: any,
    protected row: Row,
    protected column: any,
    protected dataSet: DataSet
  ) {
    this.newValue = value;
  }

  public getColumn(): Column {
    return this.column;
  }

  public getValidator(): AbstractControl {
    if (
      this.dataSet.getRowValidator(
        this.getRow().index,
        this.getRow().getData().uid
      )
    ) {
      return this.dataSet.getRowValidator(
        this.getRow().index,
        this.getRow().getData().uid
      ).controls[this.column.id];
    }
  }

  public getRow(): Row {
    return this.row;
  }

  public getInitialValue(): any {
    const valid = this.column.getValuePrepareFunction() instanceof Function;
    const prepare = valid
      ? this.column.getValuePrepareFunction()
      : Cell.PREPARE;
    return prepare.call(null, this.value, this.row.getData());
    // return this.getValidator().value;
  }

  public getValue(): any {
    return this.getValidator().value;
  }

  public setValue(value: any): any {
    this.newValue = value;
  }

  public getId(): string {
    return this.getColumn().id;
  }

  public getTitle(): string {
    return this.getColumn().title;
  }

  public isEditable(): boolean {
    if (this.getRow().index === -1) {
      return this.getColumn().isAddable;
    } else {
      return this.getColumn().isEditable;
    }
  }

  public getToolTip(): any {
    if (this.getColumn().toolTip) {
      return this.getColumn().toolTip;
    } else {
      return null;
    }
  }
  public getMaxLength(): any {
    if (this.getColumn().maxLength) {
      return this.getColumn().maxLength;
    } else {
      return null;
    }
  }
}
